import React from "react";
import Header from "../../components/default/Header";
import Tittle from "../../components/default/Tittle";
import Container from "../../components/default/Container";
import Content from "../../components/default/Content";
import ContentEntitie from "../../components/UpdateContainerEntitie/ContentEntitie";

const Main = () => {
  return (
    <div>
      <Header />
      <Container>
        <Content>
          <Tittle text="Selecione a View a ser Editada" />
          <ContentEntitie />
        </Content>
      </Container>
    </div>
  );
};

export default Main;
